module.exports = __webpack_public_path__ + "media/images/flags/ly-0ea8dfcec5cc820043a4a07c40a56fdc.svg";